import { render, staticRenderFns } from "./APlayIcon.vue?vue&type=template&id=51c67d4d&scoped=true&"
import script from "./APlayIcon.vue?vue&type=script&lang=js&"
export * from "./APlayIcon.vue?vue&type=script&lang=js&"
import style0 from "./APlayIcon.vue?vue&type=style&index=0&id=51c67d4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c67d4d",
  null
  
)

export default component.exports